import { useEffect } from 'react';
import authService from '../services/auth';
import './Login.css';

const Login = () => {
  useEffect(() => {
    // Initialize Google Sign-In when component mounts
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleResponse,
        auto_select: false,
        cancel_on_tap_outside: false
      });

      // Render the sign-in button
      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-button'),
        {
          theme: 'filled_blue',
          size: 'large',
          text: 'signin_with',
          shape: 'rectangular',
          width: 250
        }
      );
    } else {
      // If Google Identity Services isn't loaded yet, retry after a short delay
      setTimeout(() => {
        if (window.google) {
          window.google.accounts.id.initialize({
            client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
            callback: handleGoogleResponse,
            auto_select: false,
            cancel_on_tap_outside: false
          });

          window.google.accounts.id.renderButton(
            document.getElementById('google-signin-button'),
            {
              theme: 'filled_blue',
              size: 'large',
              text: 'signin_with',
              shape: 'rectangular',
              width: 250
            }
          );
        }
      }, 1000);
    }
  }, []);

  const handleGoogleResponse = async (response) => {
    try {
      await authService.handleGoogleResponse(response);
    } catch (error) {
      console.error('Sign-in failed:', error);
      
      // Show more informative error messages
      if (error.message.includes('Rate limited') || error.message.includes('wait')) {
        alert(`Authentication temporarily unavailable: ${error.message}`);
      } else if (error.message.includes('429') || error.message.includes('Too many')) {
        alert('Too many sign-in attempts. Please wait a few minutes and try again.');
      } else {
        alert('Sign-in failed. Please check your internet connection and try again.');
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-content">
        <h1 className="login-title">The Heist<br />Framework</h1>
        <p className="login-subtitle">
          Use your Google credentials to access<br />the Framework and create job structure.
        </p>
        <div className="login-button-container">
          <div id="google-signin-button" className="google-signin-container"></div>
        </div>
      </div>
    </div>
  );
};

export default Login;